/**
 * URLs baked in at build time by tsup — see tsup.config.ts.
 * `process.env.*` refs here are compile-time string replacements, not runtime lookups.
 */
declare const process: {
  env: {
    SSO_CLIENT_URL: string;
    SSO_SERVER_URL: string;
  };
};

export const ssoClientUrl: string = process.env.SSO_CLIENT_URL;
export const ssoServerUrl: string = process.env.SSO_SERVER_URL;
